export function formatUwi(uwi) {
  try {
    // Format Canadian UWI, return UWI as is for US wells.
    if (uwi.length > 12 && (uwi.match(/\d[a-z]/ig)?.length === 1 || uwi.match(/\d[a-z]/ig)?.length === 2)) { // DLS well
      let readableUwi = ""
      readableUwi = readableUwi.concat("",uwi.substring(0,3)); // 102
      readableUwi = readableUwi.concat("/",uwi.substring(3,5)); // /12
      readableUwi = readableUwi.concat("-",uwi.substring(5,7)); // -29
      readableUwi = readableUwi.concat("-",uwi.substring(7,10)); // -078
      readableUwi = readableUwi.concat("-",uwi.substring(10,14)); // -11W6
      readableUwi = readableUwi.concat("/",uwi.substring(14,)); // /00
      return readableUwi;
    } else if ((uwi.match(/[a-zA-Z]/g) && uwi.match(/[a-zA-Z]/g).length > 1) && 
      (uwi.match(/[0-9]/g) && uwi.match(/[0-9]/g).length > 10)
    ) { // NTS well
      let readableUwi = ""
      readableUwi = readableUwi.concat("",uwi.substring(0,3)); // 200
      readableUwi = readableUwi.concat("/",uwi.substring(3,4)); // /D
      readableUwi = readableUwi.concat("-",uwi.substring(4,7)); // -088
      readableUwi = readableUwi.concat("-",uwi.substring(7,8)); // -B
      readableUwi = readableUwi.concat("/",uwi.substring(8,11)); // /094
      readableUwi = readableUwi.concat("-",uwi.substring(11,12)); // -B
      readableUwi = readableUwi.concat("-",uwi.substring(12,14)); // -16
      readableUwi = readableUwi.concat("/",uwi.substring(14,)); // /00
      return readableUwi;
    } else { // US and other wells
      return uwi;
    };
  } catch (error) {
    return uwi;
  };
};